export default __webpack_public_path__ + "static/_iphone-Swap 1-c77ba5a75661212bd2199ddd6a9f4056.png";